import { Link, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";

export default function Nav() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const onLanding = location.pathname === "/";

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-nav"
      className={`fixed top-0 left-0 right-0 z-40 transition-all duration-500 ${
        scrolled
          ? "bg-[#FAFAF7]/85 backdrop-blur-xl border-b border-slate-200"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-5 flex items-center justify-between">
        <Link
          to="/"
          data-testid="brand-link"
          className="flex items-baseline gap-2 group"
        >
          <span className="font-serif text-2xl tracking-tight text-slate-900">
            FDE
          </span>
          <span className="hidden sm:inline text-xs font-mono uppercase tracking-[0.24em] text-slate-500 group-hover:text-slate-900 transition-colors">
            AI Practitioner
          </span>
        </Link>

        <nav className="hidden md:flex items-center gap-10 text-sm font-sans text-slate-600">
          {onLanding && (
            <>
              <a
                href="#philosophy"
                data-testid="nav-philosophy-link"
                className="hover:text-slate-900 transition-colors"
              >
                Philosophy
              </a>
              <a
                href="#curriculum"
                data-testid="nav-curriculum-link"
                className="hover:text-slate-900 transition-colors"
              >
                Curriculum
              </a>
              <a
                href="#projects"
                data-testid="nav-projects-link"
                className="hover:text-slate-900 transition-colors"
              >
                Projects
              </a>
              <a
                href="#instructor"
                data-testid="nav-instructor-link"
                className="hover:text-slate-900 transition-colors"
              >
                Instructor
              </a>
            </>
          )}
          <Link
            to="/apply"
            data-testid="nav-apply-btn"
            className="bg-slate-900 text-white px-5 py-2.5 hover:bg-slate-800 transition-colors font-medium"
          >
            Apply
          </Link>
        </nav>

        <button
          data-testid="nav-mobile-toggle"
          onClick={() => setOpen((v) => !v)}
          className="md:hidden text-slate-900 font-mono text-xs uppercase tracking-widest"
          aria-label="Toggle menu"
        >
          {open ? "Close" : "Menu"}
        </button>
      </div>

      {open && (
        <div className="md:hidden bg-[#FAFAF7] border-t border-slate-200 px-6 py-6 space-y-4 text-sm">
          {onLanding && (
            <>
              <a href="#philosophy" onClick={() => setOpen(false)} className="block text-slate-700">Philosophy</a>
              <a href="#curriculum" onClick={() => setOpen(false)} className="block text-slate-700">Curriculum</a>
              <a href="#projects" onClick={() => setOpen(false)} className="block text-slate-700">Projects</a>
              <a href="#instructor" onClick={() => setOpen(false)} className="block text-slate-700">Instructor</a>
            </>
          )}
          <Link to="/apply" onClick={() => setOpen(false)} className="inline-block bg-slate-900 text-white px-5 py-3">
            Apply Now
          </Link>
        </div>
      )}
    </header>
  );
}
